var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-tooltip" },
    [
      _c(
        "v-popups",
        {
          ref: "popups",
          attrs: {
            effect: _vm.effect,
            "custom-style": { maxWidth: `${_vm.maxWidth}px` },
            trigger: _vm.trigger,
            "show-arrow": _vm.showArrow,
            position: _vm.position,
            transition: _vm.transition,
            enterable: _vm.enterable,
            "open-delay": _vm.openDelay,
            "close-delay": _vm.closeDelay,
            "between-space": _vm.betweenSpace,
            "auto-adjust-position": _vm.autoAdjustPosition,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "reference",
                fn: function () {
                  return [_vm._t("default")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c(
            "div",
            { staticClass: "v-tooltip__main" },
            [
              _vm._t("content", function () {
                return [
                  _c("div", { staticClass: "v-tooltip__content" }, [
                    _vm._v(_vm._s(_vm.content)),
                  ]),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }